import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _defineProperty from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty"; //@ts-check

import React from 'react';
import cx from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Icon from '../../core/Icon';
import SidebarPins from './SidebarPins';
/**
 * @param {import('./types').PageCommonSidebarProps & import('@material-ui/core').WithStyles<typeof styles, true>} props
 */

var PageSidebar = function PageSidebar(props) {
  var classes = props.classes,
      variant = props.variant,
      wrapperStyle = props.wrapperStyle,
      open = props.open,
      toggle = props.toggle;

  if (variant === 'filter') {
    var options = props.options,
        value = props.value,
        onChange = props.onChange;
    return React.createElement("div", {
      className: cx(classes.root, classes.rootFilter, _defineProperty({}, classes.openFilter, open))
    }, React.createElement("div", {
      className: cx(classes.wrapper, classes.wrapperFilter),
      style: wrapperStyle
    }, React.createElement("div", {
      className: classes.expander,
      onClick: function onClick() {
        return toggle(!open);
      }
    }, React.createElement(Icon, {
      type: open ? 'left-double' : 'right-double',
      className: classes.expanderIcon
    })), React.createElement(SidebarPins, {
      options: options,
      value: value,
      onChange: onChange,
      tooltips: open
    })));
  } else if (variant === 'property') {
    var children = props.children,
        width = props.width;
    return React.createElement("div", {
      className: cx(classes.root, classes.rootProperty),
      style: {
        width: width
      }
    }, React.createElement("div", {
      className: cx(classes.wrapper, classes.wrapperProperty),
      style: _objectSpread({
        width: width
      }, wrapperStyle)
    }, children));
  } else if (variant === 'properties') {
    var _children = props.children,
        _options = props.options,
        _value = props.value,
        _onChange = props.onChange;
    return React.createElement("div", {
      className: cx(classes.root, classes.rootProperties)
    }, React.createElement("div", {
      className: cx(classes.wrapper, classes.wrapperProperties, _defineProperty({}, classes.openProperties, open)),
      style: wrapperStyle
    }, React.createElement("div", {
      className: classes.sidebarPropertiesPins,
      style: {
        top: wrapperStyle.top
      }
    }, React.createElement(SidebarPins, {
      options: _options,
      value: _value,
      onChange: _onChange,
      tooltips: open,
      style: {
        marginTop: wrapperStyle.top > 0 ? 24 : 32
      }
    })), open && React.createElement("div", {
      className: classes.sidebarProperties,
      style: {
        top: wrapperStyle.top
      }
    }, _children)));
  }

  return null;
};
/** @param {import('@material-ui/core').Theme} theme */


var styles = function styles(theme) {
  var sidebarStyle = theme.getStyle('Page.SideBar');
  return {
    root: {
      overflow: 'hidden',
      position: 'relative',
      fontFamily: sidebarStyle.fontFamily
    },
    rootFilter: {
      width: sidebarStyle.collapsedWidth
    },
    rootProperty: {
      width: sidebarStyle.propertyWidth
    },
    rootProperties: {
      width: sidebarStyle.propertiesWidth
    },
    wrapper: {
      position: 'fixed',
      backgroundColor: sidebarStyle.backgroundColor,
      top: 0,
      bottom: 0
    },
    wrapperFilter: {
      width: sidebarStyle.collapsedWidth,
      overflowX: 'hidden',
      '$openFilter &': {
        width: sidebarStyle.filterWidth
      }
    },
    wrapperProperty: {
      width: theme.common.properties.width,
      padding: theme.spacing(2),
      overflow: 'auto'
    },
    wrapperProperties: {
      width: sidebarStyle.collapsedWidth
    },
    sidebarPropertiesPins: {
      width: sidebarStyle.collapsedWidth,
      overflowX: 'hidden',
      position: 'fixed',
      top: 0,
      bottom: 0,
      backgroundColor: darken(sidebarStyle.backgroundColor, 0.1)
    },
    sidebarProperties: {
      width: sidebarStyle.propertiesWidth,
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: sidebarStyle.collapsedWidth,
      zIndex: 1,
      overflow: 'auto',
      backgroundColor: sidebarStyle.backgroundColor
    },
    openProperties: {
      width: sidebarStyle.collapsedWidth + sidebarStyle.propertiesWidth
    },
    openFilter: {
      width: sidebarStyle.propertiesWidth
    },
    expander: {
      position: 'absolute',
      right: theme.spacing(0.5),
      left: 0,
      textAlign: 'right',
      cursor: 'pointer'
    },
    expanderIcon: {
      fontSize: '.6rem'
    }
  };
};

PageSidebar.defaultProps = {
  variant: 'filter',
  options: []
};
export default withStyles(styles, {
  name: 'ECPageSidebar',
  withTheme: true
})(PageSidebar);